import React from 'react';
import '../styles/FontSize.css';

const FontSize = ({ textSize, setTextSize }) => {
  const handleChangeTextSize = (e) => {
    setTextSize(e.target.value);
  };
  return (
    <div>
      <div className='font-size-wrapper'>
        <label htmlFor='textSize'>Ukuran Teks:</label>
        <input
          type='number'
          id='textSize'
          className='font-size-input'
          value={textSize}
          onChange={handleChangeTextSize}
        />
      </div>
    </div>
  );
};

export default FontSize;
